import { useControls } from "leva";
import Mercedes from "./Mercedes";
import Pavement from "./Pavement";
import Pergolas from "./Pergolas";
import Tesla from "./Tesla";
import { BakeShadows, PivotControls } from "@react-three/drei";
import Grass from "./Grass";
import { ThreeContext } from "./Context";
import { useContext } from "react";

export default function Model({data}){

    const List = Object.keys(data); // Get List of Names in JSON
    
    const {debug} = useContext(ThreeContext);

    const { Modele } = useControls('Pergolas', {
      Modele : { value : "Asymetrique XL", options : List}
    })
    
    const PergolasParam = data[Modele].Pergolas;
    const MercedesParam = data[Modele].Mercedes;
    const TeslaParam = data[Modele].Tesla;
    const PavementParam = data[Modele].Pavement;


    return(
        <>
            <Pergolas data={data} Position={PergolasParam.Position} Rotation={PergolasParam.Rotation} Modele={Modele}/>
            { TeslaParam.Visible && <Tesla position={TeslaParam.Position} scale={3} />  }            
            { MercedesParam.Visible && <Mercedes position={MercedesParam.Position} scale={3} /> }
            <Pavement Size={PavementParam.Size}/>      

            {/* GRASS */}
            <PivotControls anchor={[0, 0, 0]} activeAxes={[debug, debug, debug]} visible={debug} depthTest={false} >
            
            <Grass 
                options={{bW: 0.12, bH: 1, joints: 5}} 

                circle={true} 
                widthX={80} 
                widthZ={80}
                segments={12} 
                instances={60000} 
                radius={30}

                flat={0} 
                hillScale={25}
                
                position={[0,0,0]}
                rotation={[0,0,0]}
                
                
                bW={0.12}
                bH={0.9} 
                joints={5}

                underWater={false}
                UnderWaterHeight={-1}
                
                groundColor="#361b11" 
                stencil={false} 

                hole={true}
                IsCenterHole={true}
                SquareHole={true}
                SquareHoleWidth={[2.85, 1.45]}
                Pavement={data[Modele].Pavement}
                holeRadius={6.5}
            />  
            </PivotControls>
            <BakeShadows key={Modele} />  
        </>
    )
}